import * as React from "react";
import { DefaultLabel, RelativeTime } from "components/common";
import StringUtils from "util/StringUtils";
import ProviderName from "ai-management/components/ProviderName";
import DisabledLabel from "ai-management/model-providers/overview/DisabledLabel";
const columnRenderers = {
  attributes: {
    provider: {
      renderCell: (_value, provider) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider.provider }), provider.is_default && /* @__PURE__ */ React.createElement(DefaultLabel, null), !provider.enabled && /* @__PURE__ */ React.createElement(DisabledLabel, null))
    },
    default_model_id: {
      staticWidth: 300
    },
    used_by_features: {
      renderCell: (count) => `${count} ${StringUtils.pluralize(count, "feature", "features")}`,
      staticWidth: 100
    },
    last_request_at: {
      renderCell: (lastRequestAt) => lastRequestAt && /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: lastRequestAt }),
      staticWidth: 150
    }
  }
};
export default columnRenderers;
